import { useCallback, useRef } from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import { CoverType } from '@/modules/corporate/components/ImageList/types';

const useAddCoverDialog = () => {
  const [open, { toggle }] = useToggle(false);
  const coverDialogRef = useRef<{ callback: any; cover: any }>();
  const openDialog = useCallback(
    (callback?: any, cover?: any) => {
      coverDialogRef.current = {
        callback,
        cover,
      };
      toggle();
    },
    [toggle],
  );

  const onCloseDialog = useCallback(() => {
    toggle();
    coverDialogRef.current = undefined;
  }, [toggle]);

  const onSubmit = useCallback((selectedCover?: CoverType) => {
    coverDialogRef.current?.callback(selectedCover);
  }, []);

  return { onSubmit, openDialog, onCloseDialog, cover: coverDialogRef.current?.cover, open };
};

export default useAddCoverDialog;
